/**
 * product-gallery.js — Product image gallery.
 * Main image: .product-gallery-main img
 * Thumbnails: .product-gallery-thumb buttons with data-image-src
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var mainContainer = document.querySelector('[data-gallery-main]');
    var thumbs    = document.querySelectorAll('[data-gallery-thumbs] .product-gallery-thumb');
    if (!mainContainer || thumbs.length === 0) return;

    var mainImage = mainContainer.querySelector('img');
    if (!mainImage) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var newSrc = thumb.getAttribute('data-image-src');
        if (!newSrc) return;

        mainImage.style.opacity = '0';
        setTimeout(function () {
          mainImage.src = newSrc;
          mainImage.style.opacity = '1';
        }, 150);

        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });

    // Fade transition
    mainImage.style.transition = 'opacity 200ms ease';
  });
})();
